export enum EProduct {
  QWIK = 'QWIK',
  VALUT = 'VALUT.NET',
  TRAVEL_CARDS = 'Travel.Cards',
}

export const stringToEProduct = (str: string) =>
  EProduct[str.toUpperCase() as keyof typeof EProduct]
